import { BillingContact, BillingContactAddress } from '@atlassian/cssxp-types-billing';
import isEmpty from 'lodash/isEmpty';
import negate from 'lodash/negate';
import * as React from 'react';

export interface Props {
  contact?: BillingContact;
  block: string;
}

const getCityStatePostalCode = ({ city, state, postalCode }: BillingContactAddress): string => {
  if (city && state) {
    return postalCode && !isEmpty(postalCode) ? `${city}, ${state} ${postalCode}` : `${city}, ${state}`;
  }

  return [city, state, postalCode].filter(negate(isEmpty)).join(' ');
};

const BillingShippingDocDetailBlock = ({ contact, block }: Props) => {
  if (!contact) {
    return <div>{block === 'shipTo' ? 'Shipping ' : 'Billing '}information not found</div>;
  }

  const displayName = contact.fullName ?? 'No name';

  const hasFullAddress = contact.address.address1 && contact.address.country;

  return (
    <div className="billing-shipping-detail" data-testid={`billing-shipping-doc-${block}`}>
      {(block === 'billTo' || block === 'shipTo') && (
        <div className="billing-shipping-detail-name" data-testid="billing-shipping-doc-name">
          <strong>{displayName}</strong>
        </div>
      )}

      <div className="billing-shipping-detail-tax-id">Tax ID: {contact.taxId || 'Not found'}</div>

      {hasFullAddress ? (
        <>
          <div className="billing-shipping-detail-address">{contact.address.address1}</div>
          {contact.address.address2 && (
            <div className="billing-shipping-detail-address">{contact.address.address2}</div>
          )}
          <div className="billing-shipping-detail-city" data-testid="billing-shipping-detail-city-state">
            {getCityStatePostalCode(contact.address)}
          </div>

          <div className="billing-shipping-detail-country">{contact.address.country}</div>
        </>
      ) : (
        <div> Address: Not found</div>
      )}
    </div>
  );
};

export default BillingShippingDocDetailBlock;
